import request from "@/common/request";
import { CashbackCrmBonusAvailableResponse, CashbackCrmBonusCampanhasResponse, CashbackCrmBonusFinalizacaoResponse, CashbackCrmBonusPINResponse, CashbackCrmBonusTokenResponse } from "@/models/Cashback";

const basePath = '/gift-back'

export const possuiPluginCrmBonusConfigurado = async (lojaId: string): Promise<boolean> => 
	request.get(`${basePath}/crm-bonus-configurado/${lojaId}`)

export const validarToken = async (lojaId: string): Promise<CashbackCrmBonusTokenResponse> =>
	request.post(`${basePath}/autenticacao/${lojaId}`)

export const enviarPINParaCliente = async (cnpjOuCpfCliente: string, lojaId: string, valor: number, itens: any): Promise<CashbackCrmBonusPINResponse> =>
	request.post(`${basePath}/enviar-PIN?cnpjOuCpfCliente=${cnpjOuCpfCliente}&lojaId=${lojaId}&valor=${valor}`, itens)

export const reenviarPINParaCliente = async (cnpjOuCpfCliente: string, params: any): Promise<CashbackCrmBonusPINResponse> =>
	request.post(`${basePath}/reenviar-PIN?cnpjOuCpfCliente=${cnpjOuCpfCliente}`, {...params})

export const validarPINInformado = async (params: any, pin: string): Promise<CashbackCrmBonusPINResponse> =>
	request.post(`${basePath}/validar-PIN?pin=${pin}`, {...params})

export const consultaCashbackCrmBonusCliente = async (userId: string, requestHash: string, lojaId: string, valor: number, params: any): Promise<CashbackCrmBonusAvailableResponse> =>
	request.post(`${basePath}/consulta-bonus?userId=${userId}&requestHash=${requestHash}&lojaId=${lojaId}&valor=${valor}`, params)

export const consultarCampanhasDisponiveisCrmBonus = async (params: any): Promise<CashbackCrmBonusCampanhasResponse[]> =>
	request.post(`${basePath}/campanhas-disponiveis`, {...params})

export const finalizarVendaCashbackCrmBonus = async (params: any, campanhaId: string, pinMaster: boolean): Promise<CashbackCrmBonusFinalizacaoResponse> => 
	request.post(`${basePath}/finalizar-bonus?campanhaId=${campanhaId}&pinMaster=${pinMaster}`, {...params})

export const enviarVendaCrmBonus = async (params: any): Promise<string> => 
	request.post(`${basePath}/envia-venda`, {...params})

export const cancelarCrmBonus = async (vendaId: string, lojaId: string): Promise<void> =>
	request.post(`${basePath}/cancela-bonus/${vendaId}?lojaId=${lojaId}`)

